import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-marble flex items-center justify-center px-6">
      <div className="marble-veil" />
      <div className="max-w-md w-full bg-white/80 backdrop-blur-xl border border-gold/30 rounded-sm p-12 text-center">
        <h1 className="font-serif-lux text-4xl text-charcoal mb-4">Checkout cancelled</h1>
        <p className="text-sm text-charcoal/60 font-light leading-relaxed mb-8">
          No charge was made. Your cart has been saved and is waiting for you whenever you're ready.
        </p>
        <Link
          data-testid="cancel-back-to-shop-link"
          to="/"
          className="inline-flex items-center gap-2 px-10 py-4 bg-gold text-charcoal text-xs tracking-[0.25em] uppercase font-semibold rounded-full hover:bg-gold-dark transition-colors"
        >
          <ArrowLeft size={14} />
          Return to Shop
        </Link>
      </div>
    </div>
  );
}
